import { useState, useEffect } from 'react'

export const ShareButtons = ({
  title,
  description,
  showNotification,
  setShowNotification,
}) => {
  const [url, setUrl] = useState('')

  useEffect(() => {
    setUrl(window.location.href)
  }, [])

  const shareData = {
    title: title,
    text: description,
    url: url,
  }

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share(shareData)
      }
    } catch (err) {
      console.log('Error sharing:', err)
    }
  }

  const handleCopyLink = () => {
    try {
      navigator.clipboard.writeText(url)
      console.log('URL copied to clipboard:', url)
      setShowNotification(true)
    } catch (err) {
      console.log('Failed to copy URL:', err)
    }
  }

  return (
    <div className="flex items-end gap-4 lg:flex-col">
      <button
        onClick={handleShare}
        className="plausible-event-name=Share border border-neutral-200 p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-900 lg:hidden lg:border-0"
        title="Share"
      >
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        </svg>
      </button>

      <button
        onClick={() => {
          handleCopyLink()
        }}
        className="plausible-event-name=Copy+Link relative hidden h-9 w-9 items-center justify-center border border-neutral-200 p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-900 lg:flex lg:border-0"
        title="Copy Link"
      >
        <svg
          className="absolute left-1/2 top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="2"
          >
            <path d="m12 17l-1.5 1.5a3.536 3.536 0 0 1-5 0v0a3.536 3.536 0 0 1 0-5l3-3a3.536 3.536 0 0 1 5 0v0" />
            <path d="m12 7l1.5-1.5a3.536 3.536 0 0 1 5 0v0a3.536 3.536 0 0 1 0 5l-3 3a3.536 3.536 0 0 1-5 0v0" />
          </g>
        </svg>
      </button>

      <a
        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="plausible-event-name=Share+X border border-neutral-200 p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-900 lg:border-0"
        title="Share on X"
      >
        <svg
          className="h-5 w-5"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584l-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"
          />
        </svg>
      </a>

      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="plausible-event-name=Share+Facebook border border-neutral-200 p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-[#4267B2] lg:border-0"
        title="Share on Facebook"
      >
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      </a>

      <a
        href={`https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="plausible-event-name=Share+LinkedIn border border-neutral-200 p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-[#0077B5] lg:border-0"
        title="Share on LinkedIn"
      >
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.73V1.73C24 .77 23.21 0 22.23 0zM7.12 20.45H3.56V9h3.56v11.45zM5.34 7.56c-1.14 0-2.06-.93-2.06-2.08 0-1.14.92-2.06 2.06-2.06 1.14 0 2.06.92 2.06 2.06 0 1.15-.92 2.08-2.06 2.08zm14.45 12.89h-3.56V14.8c0-1.34-.03-3.07-1.87-3.07-1.88 0-2.17 1.46-2.17 2.97v6.75h-3.56V9h3.42v1.56h.05c.48-.91 1.66-1.87 3.42-1.87 3.65 0 4.32 2.4 4.32 5.52v6.24z" />
        </svg>
      </a>
    </div>
  )
}
